import { format } from "date-fns";

export const sortObjetivosByColor = (objetivos) => {
    const colores = {
        0: "#C2272D",
        1: "#da8e1d",
        2: "#FFC600",
        3: "#41B900",
        4: "#bdbdbd",
    };
    const sortedObjetivos = [];

    Object.values(colores).forEach((color) => {
        objetivos.forEach((objetivo) => {
            if (objetivo.color === color) {
                sortedObjetivos.push(objetivo);
            }
        });
    });
    return sortedObjetivos;
};

export const sortObjetivosByCustomColors = (objetivos, colores) => {
    const uniqueColores = Array.from(new Set(Object.values(colores)));
    const sortedObjetivos = [];

    uniqueColores.forEach((color) => {
        objetivos.forEach((objetivo) => {
            if (objetivo.color === color) {
                sortedObjetivos.push(objetivo);
            }
        });
    });

    return sortedObjetivos;
};

export const getImagenAtentus = (tamano) => {
    if (tamano > 960) {
        return "/images/logo_atentus_azul.png";
    }
    return "/images/logo_circulo_atentus.png";
};

export const getJustified = (tamano, tipo) => {
    if (tamano > 960) {
        if (tipo === "titulo") {
            return "flex-start";
        } else {
            return "flex-end";
        }
    } else {
        return "center";
    }
};

export const playSound = () => {
    const audio = new Audio("/audios/alert.mp3");
    audio.play();
};

export function getDifferenceLastStatus(lastDate) {
    if (lastDate === "N/I") return "Sin monitoreo";
    return format(new Date(lastDate), "dd-MM-yyyy HH:mm:ss");
}
